import util from '../util'

let controller = 'ApiResources'
export default {
    GetAll: function (dto) {
        return util.Axios.GetAll(controller, dto)
    },
    Post: function (dto) {
        return util.Axios.Post(controller, dto)
    },
    Put: function (id, dto) {
        return util.Axios.Put(controller, id, dto)
    },
}